<template>
  <div>
    <banner />
    <news />
    <scene />
    <demand />
    <results />
    <activity />
    <footer-box />
  </div>
</template>

<script>
import banner from "./components/banner.vue";
import news from "./components/news.vue";
import scene from "./components/scene.vue";
import demand from "./components/demand.vue";
import results from "./components/results.vue";
import activity from "./components/activity.vue";
import footerBox from "./components/footerBox.vue";
import "jquery.cookie";

export default {
  components: {
    banner,
    news,
    scene,
    demand,
    results,
    activity,
    footerBox,
  },
  mounted() {},
};
</script>

<style></style>
